export default "__VITE_ASSET__CwYAt22u__"